<script setup>
import {  defineProps } from 'vue';

defineProps({
  width: {
    type: String,
    required: true,
  },
  align: {
    type: String,
    default: 'left',
  }
});

</script>

<template>
  <div
    :style="'width: ' + width +'rem;'"
    :class="[
      'cursor-not-allowed bg-slate-700 text-slate-300 pt-2.5 border-b border-t border-b-slate-700 border-t-slate-700 text-' + align,
    ]"
  >
    <slot></slot>
  </div>
</template>
